import React from 'react'
import { withStyles } from '@material-ui/core/styles'

const styles = () => ({
  root: {
    width: '100%',
  },
  inputWrap: {
    display: 'flex',
    alignItems: 'center',
    height: 56,
    border: '1px solid #C0D2E5',
    background: '#FFFFFF',
    borderRadius: 12,
    paddingLeft: 8,
    paddingRight: 8,
    boxShadow: '0px 1px 2px 0px #1741970D',
  },
  input: {
    flex: 1,
    border: 'none',
    outline: 'none',
    fontFamily: 'var(--font-sans)',
    fontSize: 16,
    lineHeight: '24px',
    color: '#181D27',
    background: 'transparent',
  },
  placeholder: {
    color: '#9AA6B2',
  },
  btn: {
    width: 32,
    height: 32,
    border: 'none',
    background: '#0C70E8',
    display: 'grid',
    placeItems: 'center',
    cursor: 'pointer',
    borderRadius: '46.53px',
    gap: '7.44px',
    borderWidth: '0.93px',
    padding: '7.44px',
  },
  svg: {
    display: 'block',
    width: '14.620189666748047',
    height: '14.620189666748047',
    borderWidth: '1.4px',
  },
})

function InputSearchImpl(classes, onResults, cleanText, handleData) {
  function triggerSearch() {
    if (onResults) {
      onResults(handleData.textValue)
      const el = document.getElementById('search-video')
      if (el) el.value = ''
      if (cleanText) cleanText('')
    }
  }

  function onKeyUp(e) {
    handleData.textValue = e.target.value
    if (e.keyCode === 13) triggerSearch()
  }

  return (
    <div className={classes.root}>
      <div className={classes.inputWrap}>
        <input
          id='search-video'
          className={classes.input}
          onKeyUp={onKeyUp}
          placeholder='Search'
          type='text'
        />
        <button type='button' className={classes.btn} onClick={triggerSearch} aria-label='Search'>
          <svg className={classes.svg} viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.83655 14.0582C11.477 14.0582 14.428 11.1072 14.428 7.4668C14.428 3.82639 11.477 0.875366 7.83655 0.875366C4.19614 0.875366 1.24512 3.82639 1.24512 7.4668C1.24512 11.1072 4.19614 14.0582 7.83655 14.0582Z" stroke="white" strokeWidth="1.39583" strokeLinejoin="round"/>
            <path d="M10.0299 4.88569C9.74207 4.59732 9.40016 4.36862 9.02376 4.21272C8.64736 4.05682 8.24387 3.9768 7.83646 3.97724C7.42905 3.9768 7.02557 4.05682 6.64917 4.21272C6.27276 4.36862 5.93086 4.59732 5.64307 4.88569M12.5753 12.2057L15.8652 15.4956" stroke="white" strokeWidth="1.39583" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>
      </div>
    </div>
  )
}

function InputSearch(props) {
  const { classes, onResults, cleanText, handleData } = props
  return InputSearchImpl(classes, onResults, cleanText, handleData)
}

InputSearch.defaultProps = {
  onResults: null,
  handleData: { textValue: '' },
}

export default withStyles(styles)(InputSearch)
